module.exports = __webpack_public_path__ + "static/media/medicash.1c5b8803.png";